// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1aZDq{padding:1rem;background-color:#f7f8f8;border:1px solid #dcdddd;border-radius:.5rem;margin-bottom:1rem}._3HidH{margin-top:1.5rem}.ULINQ{margin-bottom:.5rem}._2Qi1i{background-color:#ebebfe;color:#5656e2}._1R7cu{font-size:16px;font-size:1rem;font-weight:500;line-height:20px;line-height:1.25rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}._1R7cu,._2JikY{margin-bottom:.5rem}", ""]);
// Exports
exports.locals = {
	"information": "_1aZDq",
	"planContent": "_3HidH",
	"promotion": "ULINQ",
	"labelAccent": "_2Qi1i",
	"name": "_1R7cu",
	"price": "_2JikY"
};
module.exports = exports;
